import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    text-transform: uppercase !important;
  }
  body{
    background-color: #eff3f8;
    overflow-x: hidden;
    input {
      text-transform: uppercase;
    }
    select {
      text-transform: uppercase;
    }
    hanging-punctuation: none;
  }
  button {
    cursor: pointer;
  }
  hr, p {
    margin: 0;
  }

  .bg-orange {
    background: #FE6F5E;
  }

  .border-orange {
    border: #FE6F5E;
    outline: #FE6F5E;
  }

  .text-orange {
    color: #FE6F5E;
  }

  .bg-green {
    background: #50C878;
  }

  .border-green {
    border: #50C878;
    outline: #50C878;
  }

  .text-green {
    color: #50C878;
  }
`
